import { onMessage } from 'dom-helper';
import Browser from 'browser';

export default class FrameMessenger {
  constructor(scriptHost) {
    const win = Browser.getWindow();

    this.scriptHost = scriptHost;
    this.handlers = {};

    onMessage(win, (event) => {
      this.handleMessage(event);
    });
  }

  receive(eventName, handler) {
    // This is equivalent to this.handlers.hasOwnProperty(eventName)
    if (!Object.prototype.hasOwnProperty.call(this.handlers, eventName)) {
      this.handlers[eventName] = [];
    }

    this.handlers[eventName].push(handler);
  }

  static send(frame, event, data, host) {
    const win = Browser.getWindow();

    const frameName = win.name || 'top';
    const message = win.JSON.stringify({
      event,
      data,
      frameName,
    });

    frame.postMessage(message, host);
  }

  static sendToParent(event, data) {
    const win = Browser.getWindow();

    FrameMessenger.send(win.parent, event, data, '*');
  }

  send(frame, event, data) {
    FrameMessenger.send(frame, event, data, this.scriptHost);
  }

  handleMessage(messageEvent) {
    const win = Browser.getWindow();
    let messageData;

    try {
      messageData = win.JSON.parse(messageEvent.data);
    } catch (e) {
      messageData = null;
    }

    if (messageData && messageData.event && messageData.frameName) {
      const { event, frameName, data } = messageData;

      this.fireEvent(event, frameName, data, messageEvent);
    }
  }

  fireEvent(event, frameName, data, originalEvent) {
    const handler = this.handlers[event];

    if (handler) {
      handler.forEach((func) => {
        func(frameName, data, originalEvent);
      });
    }
  }
}



// WEBPACK FOOTER //
// ./~/frame-messenger/src/frame-messenger.js